module.exports = __webpack_public_path__ + "static/media/promo-6.1e3f0b5f.png";